import type { GetHouseholdFamilyTreeQuery } from '../graphql/FamilyTree.generated';
import mock1 from './mock-1.json';
import mock2 from './mock-2.json';
import mock3 from './mock-3.json';
import mock4 from './mock-4.json';
import mock5 from './mock-5.json';
import mock6 from './mock-6.json';
import mock7 from './mock-7.json';
import mock8 from './mock-8.json';
import mock9 from './mock-9.json';
import mock10 from './mock-10.json';
import mock11 from './mock-11.json';
import mock12 from './mock-12.json';
import mock13 from './mock-13.json';
import mock14 from './mock-14.json';
import mock15 from './mock-15.json';
import mock16 from './mock-16.json';
import mock17 from './mock-17.json';
import mock18 from './mock-18.json';
import mock19 from './mock-19.json';

/**
 * Mock family tree data for manual UI testing.
 * Use ?familyTreeMock=N in the URL to load mock data (where N is 1-19).
 */
export const familyTreeMocks: Record<
  string,
  { data: GetHouseholdFamilyTreeQuery }
> = {
  '1': { data: mock1 as unknown as GetHouseholdFamilyTreeQuery },
  '2': { data: mock2 as unknown as GetHouseholdFamilyTreeQuery },
  '3': { data: mock3 as unknown as GetHouseholdFamilyTreeQuery },
  '4': { data: mock4 as unknown as GetHouseholdFamilyTreeQuery },
  '5': { data: mock5 as unknown as GetHouseholdFamilyTreeQuery },
  '6': { data: mock6 as unknown as GetHouseholdFamilyTreeQuery },
  '7': { data: mock7 as unknown as GetHouseholdFamilyTreeQuery },
  '8': { data: mock8 as unknown as GetHouseholdFamilyTreeQuery },
  '9': { data: mock9 as unknown as GetHouseholdFamilyTreeQuery },
  '10': { data: mock10 as unknown as GetHouseholdFamilyTreeQuery },
  '11': { data: mock11 as unknown as GetHouseholdFamilyTreeQuery },
  '12': { data: mock12 as unknown as GetHouseholdFamilyTreeQuery },
  '13': { data: mock13 as unknown as GetHouseholdFamilyTreeQuery },
  '14': { data: mock14 as unknown as GetHouseholdFamilyTreeQuery },
  '15': { data: mock15 as unknown as GetHouseholdFamilyTreeQuery },
  '16': { data: mock16 as unknown as GetHouseholdFamilyTreeQuery },
  '17': { data: mock17 as unknown as GetHouseholdFamilyTreeQuery },
  '18': { data: mock18 as unknown as GetHouseholdFamilyTreeQuery },
  '19': { data: mock19 as unknown as GetHouseholdFamilyTreeQuery },
};

export const mockDescriptions: Record<string, string> = {
  '1': 'Simple nuclear family (2 parents, 2 children)',
  '2': 'Large extended family (20+ people, 6 generations)',
  '3': 'Complex blended family (multiple marriages, stepchildren)',
  '4': 'Multiple divorces (3 marriages, children from each marriage)',
  '5': 'Multi-generational with deceased members (7 generations)',
  '6': 'Single parent with children and extended family',
  '7': 'Wide family tree (many siblings)',
  '8': 'Edge cases (hidden individuals, warnings, notes)',
  '9': 'British Royal Family (Charles, Diana, Camilla, stepchildren)',
  '10': 'Kardashian-Jenner family (Kris, Robert Kardashian, Caitlyn Jenner)',
  '11': 'Five serial marriages plus stepchildren (Hollywood style)',
  '12': 'Weasley family (Harry Potter: large family with 7 children)',
  '13': 'Skywalker family (Star Wars: multi-generational, all deceased)',
  '14': 'Stark family (Game of Thrones: tragedy, many deceased members)',
  '15': 'MASSIVE: 12 children, 33 grandchildren, 4 generations (58 people)',
  '16': 'MASSIVE: Multi-branch extended family with many cousins (50 people)',
  '17': 'Real-world complex: ex-spouse with own ex, stepchild, half-siblings, in-laws',
  '18': 'Single-parent children (children with only one parent, with multi-generational family)',
  '19': 'Ex-spouse with children (T-shaped connection, child with own family)',
};
